document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pk-society-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-pk-society-open');
      var modal = document.querySelector('[data-pk-society-modal="' + id + '"]');
      if (!modal) return;
      modal.hidden = false;
      document.body.classList.add('pk-modal-open');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          modal.classList.add('pk-modal--visible');
        });
      });
    });
  });

  function closeSocietyModal(modal) {
    modal.classList.remove('pk-modal--visible');
    document.body.classList.remove('pk-modal-open');
    setTimeout(function () {
      modal.hidden = true;
    }, 280);
  }

  document.querySelectorAll('[data-pk-society-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      var id = el.getAttribute('data-pk-society-close');
      var modal = document.querySelector('[data-pk-society-modal="' + id + '"]');
      if (!modal) return;
      closeSocietyModal(modal);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-pk-society-modal]').forEach(function (modal) {
      if (!modal.hidden) closeSocietyModal(modal);
    });
  });
});